<form *ngIf="showGrossempfaengerAdresse" [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="d-sm-none col-form-label"
           for="grossempfaengeradressePostleitzahl{{index}}">{{ 'COMMON_UI.ADRESSEN.GROSSEMPFAENGERADRESSE.PLZ' | translate }}</label>
    <label class="d-none d-sm-inline col-sm-4 col-form-label">
      {{ 'COMMON_UI.ADRESSEN.GROSSEMPFAENGERADRESSE.PLZ_ORT' | translate }}
    </label>
    <div class="col-sm-2">
      <input class="form-control" datevMessagePath="grossempfaengeradressePostleitzahl{{objectId}}" formControlName="postleitzahl"
             id="grossempfaengeradressePostleitzahl{{index}}"
             type="text" utilsCheckValidity utilsControlState
             utilsMarkRequired utilsValidationMessage/>
    </div>

    <label class="d-sm-none col-form-label"
           for="grossempfaengeradresseOrt{{index}}">{{ 'COMMON_UI.ADRESSEN.GROSSEMPFAENGERADRESSE.ORT' | translate }}</label>
    <div class="col-sm-6">
      <input class="form-control" datevMessagePath="grossempfaengeradresseOrt{{objectId}}" formControlName="ort" id="grossempfaengeradresseOrt{{index}}"
             type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
    </div>
  </div>

</form>
